/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";
import FormInputCheckbox from "components/forms/form-checkbox";

const ConfigureComparision = () => {
  const { report, editReport } = useReportBuilder();

  const handleChange = () => {
    editReport({ config: { compare: !get(report, "config.compare") } });
  };

  return (
    <Box>
      <FormInputCheckbox
        onChange={handleChange}
        label="Show comparision"
        checked={!!get(report, "config.compare")}
      />
    </Box>
  );
};

export default ConfigureComparision;
